import { useOcppTagList } from '@services/ocpp'
import { Select, SelectProps } from '@shared/Form/Select'
import { isNil } from 'ramda'

type Props = SelectProps & {
  ownerSeq?: number
}

export const OcppTagAutoCompleteSelect = ({ ownerSeq, ...props }: Props) => {
  const { dataSource, loading } = useOcppTagList({
    pageNum: 0,
    pageSize: 9999,
  })

  const options = (dataSource?.content || []).filter((x: any) =>
    isNil(ownerSeq) ? true : x.ownerSeq === ownerSeq
  )

  return (
    <Select
      loading={loading}
      showSearch
      filterOption={(input, option) => {
        return (
          typeof option?.children === 'string' &&
          (option.children as string).includes(input)
        )
      }}
      {...props}>
      {options.map((x: any) => (
        <Select.Option key={x.id} value={x.id}>
          {x.lprNo}
        </Select.Option>
      ))}
    </Select>
  )
}

export default OcppTagAutoCompleteSelect
